import { Link, useLocation } from 'react-router'
import { CategoryChip } from '../components/CategoryChip'
import { OwnerCell } from '../list/commonCells'
import { ListDateCell } from './ListCells'
import type { ListRow } from './types'

/** The lists as cards on a phone (ED-50): name, kind, date, place or "dynamisch", number of people and owner. */
export function ListCardList({ rows }: { rows: ListRow[] }) {
  const location = useLocation()
  return (
    <ul className="flex flex-col gap-2">
      {rows.map((row) => (
        <li key={row.id} className="vonk-card relative flex flex-col gap-1 p-3">
          <Link
            to={`/relaties/lijsten/${row.id}`}
            state={{ from: location.search }}
            className="font-medium text-foreground underline-offset-2 after:absolute after:inset-0 after:content-[''] hover:underline"
          >
            {row.name}
          </Link>
          <div className="flex flex-wrap items-center gap-2 text-sm">
            {row.kind ? <CategoryChip category={row.kind} /> : null}
            <ListDateCell row={row} />
          </div>
          <p className="truncate text-sm text-muted-foreground">
            {row.type === 'dynamic' ? 'Dynamisch' : (row.location ?? 'Statisch')}
            {row.members_count === null ? '' : ` · ${row.members_count === 1 ? '1 persoon' : `${row.members_count} personen`}`}
          </p>
          <div className="text-sm">
            <OwnerCell owner={row.owner} />
          </div>
        </li>
      ))}
    </ul>
  )
}
